<template>
  <div class="mt-4">
    <div class="footer">
      <ul class="footermenu mb-0">
        <li>
          <a href="/about">About Us</a>
        </li>
        <li>
          <a href="/contact">Contact Us</a>
        </li>
        <li>
          <a href="/privacypolicy">Privacy Policy</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFooter"
};
</script>
